import * as Sentry from '@sentry/react'

import isUnauthorized from '../isUnauthorized'


/**
 * Reports a failed request to the auth service, unless the failure is only the
 * server refusing the credential.
 *
 * A refusal is ordinary: nobody has signed in, or the session ended somewhere
 * else. Anything else means the auth service is misbehaving, or never
 * answered, and is worth knowing about.
 *
 * @param {Object} error - the error the request rejected with
 * @param {Object} [error.response] - the server's answer, absent when the
 *   request never earned one
 * @param {Number} [error.response.status]
 */
export default function reportAuthFailure(error) {
  if ( isUnauthorized(error) ) {
    return
  }

  Sentry.captureException(error, { level: 'warning' })
}
